import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_personnel_files_maintained_in_line_w_legal_reqs'

export const dataPointDefinition = {
  retracedId: 'are_personnel_files_maintained_in_line_w_legal_reqs',
  name: 'Are personnel files maintained in line with legal requirements?',
  description:
    'The intent of this question is to understand if personnel files are maintained and in line with legal requirements. \r\r\n\r\r\n"Maintained" refers to keeping personnel files on-site at the facility and in an orderly fashion. \r\r\n\r\r\nConsult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ep-2--2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5960,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
